import mainRegistrationMixin from "@/mixins/registration/mainRegistrationMixin";

export default {
    mixins: [mainRegistrationMixin],
    computed: {
        couponsToRedeem: {
            get: function () {
                return this.registrationData.couponsToRedeem
            },
            set: function (value) {
                this.setRegistrationProp('couponsToRedeem', value)
            }
        },
        redeemedCoupons: {
            get: function () {
                return this.registrationData.redeemedCoupons
            },
            set: function (value) {
                this.setRegistrationProp('redeemedCoupons', value)
            }
        },
        paymentType: {
            get: function () {
                return this.registrationData.paymentType
            },
            set: function (value) {
                this.setRegistrationProp('paymentType', value)
            }
        },
        selectedPaymentType(){
            try{
                return this.eventData.availablePaymentTypes.find(availablePaymentType => availablePaymentType.id === this.paymentType)
            }catch (e) {
                return null
            }
        },
        iban: {
            get: function () {
                return this.registrationData.iban
            },
            set: function (value) {
                this.setRegistrationProp('iban', value)
            }
        },
        bic: {
            get: function () {
                return this.registrationData.bic
            },
            set: function (value) {
                this.setRegistrationProp('bic', value)
            }
        },
        alternativeAccountHolder: {
            get: function () {
                return this.registrationData.alternativeAccountHolder
            },
            set: function (value) {
                this.setRegistrationProp('alternativeAccountHolder', value)
            }
        },
        paypalOrderId: {
            get: function () {
                return this.registrationData.paypalOrderId
            },
            set: function (value) {
                this.setRegistrationProp('paypalOrderId', value)
            }
        },
        paypalAuthorizationId: {
            get: function () {
                return this.registrationData.paypalAuthorizationId
            },
            set: function (value) {
                this.setRegistrationProp('paypalAuthorizationId', value)
            }
        },
        paypalAuthorizationAmount: {
            get: function () {
                return this.registrationData.paypalAuthorizationAmount
            },
            set: function (value) {
                this.setRegistrationProp('paypalAuthorizationAmount', value)
            }
        },
        paymentMethodWhenTotal0(){
            return this.eventData?.paymentMethodWhenTotal0
        },
    },
}
